"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportShopAdd = reportShopAdd;
exports.reportShopDelete = reportShopDelete;
exports.reportShopEdit = reportShopEdit;
var _adminOperationReport = require("@/utils/adminOperationReport");
/**
 * 【操作埋点】商户管理模块上报方法
 * 实施时间：2026-05-25
 * 说明：新增/编辑/删除商户
 */

/**
 * 添加商户埋点上报
 * @param {Object} shopInfo - 商户信息
 */
function reportShopAdd(shopInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '添加商户',
    content: "\u65B0\u589E\u5546\u6237\u300C".concat(shopInfo.store_name, "\u300D\uFF0C\u8054\u7CFB\u4EBA\uFF1A").concat(shopInfo.contact, "\uFF0C\u7535\u8BDD\uFF1A").concat(shopInfo.phone),
    operation_id: 'pc_shop_add_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_shop_add_1');
}

/**
 * 编辑商户埋点上报
 * @param {number} shopId - 商户ID
 * @param {Object} shopInfo - 商户信息
 */
function reportShopEdit(shopId, shopInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '编辑商户',
    content: "\u7F16\u8F91\u5546\u6237\u300C".concat(shopInfo.store_name, "\u300D(ID:").concat(shopId, ")"),
    operation_id: 'pc_shop_edit_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_shop_edit_1');
}

/**
 * 删除商户埋点上报
 * @param {number} shopId - 商户ID
 * @param {string} shopName - 商户名称
 */
function reportShopDelete(shopId, shopName) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '删除商户',
    content: "\u5220\u9664\u5546\u6237\u300C".concat(shopName, "\u300D(ID:").concat(shopId, ")"),
    operation_id: 'pc_shop_delete_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_shop_delete_1');
}